import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeCheckSamePasswordParams = {
  newPassword: string;
};

type TypeCheckSamePasswordResponse = {
  code: string;
  message: string;
};

/**
 * @description 로그인 세션이 있는 상태에서 새 비밀번호에 대한 검증 api 요청에 사용되는 커스텀 훅
 */
const useCheckSamePassword = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeCheckSamePasswordParams) => {
      const endpoint = '/labor-accounts/password/verify';
      return axiosInstance.post<TypeCheckSamePasswordResponse>(endpoint, params);
    },
  });

  const requestCheckSamePassword = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeCheckSamePasswordParams;
    onSuccess?: (res: TypeCheckSamePasswordResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError, undefined, { showLoading: false });
  };

  return requestCheckSamePassword;
};

export default useCheckSamePassword;
